import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import HumanProxyType from './humanProxyType'
import { type Profile, ProfileSchema } from './profile'

export type HumanProxy = {
  type: HumanProxyType
  profile: Profile
}

export const HumanProxySchema: CborSchema<HumanProxy> =
  defineCborSchema<HumanProxy>({
    type: CborField({ key: 0 }),
    profile: CborField({ key: 1, type: ProfileSchema }),
  })
